import ApiService from './api.service'

const ApkService = {
    get() {

    },

    getPlombSerials(id, companyId, energyMeterTypePublicCode, serialNumber, status, page, count) {
      return ApiService.get('/api/apk/plomb-serials', {
        params: {
          Id: id,
          CompanyId: companyId,
          EnergyMeterTypePublicCode: energyMeterTypePublicCode,
          SerialNumber: serialNumber,
          Status: status,          
          Page: page,
          Count: count
        }
      })
    },

    getPaperActSerials(id, companyId, typePublicCode, serialNumber, status, page, count) {
      return ApiService.get('/api/apk/paper-act-serials', {
        params: {
          Id: id,
          CompanyId: companyId,
          TypePublicCode: typePublicCode,
          SerialNumber: serialNumber,
          Status: status,          
          Page: page,
          Count: count
        }
      })
    },

    getPaperActTypes(id) {
      return ApiService.get('/api/apk/paper-act-types', {
        params: {
          Id: id
        }
      })
    },

    createPlombSerials(energyMeterTypePublicCode, color, serialNumberStart, count, idCompany) {
      let act = {        
        energyMeterTypePublicCode: energyMeterTypePublicCode,
        color: color,
        serialNumberStart: serialNumberStart,
        count: count,
        idCompany: idCompany
      }
      return ApiService.post(`/api/apk/plomb-serials`, act)
    },

    createPaperActSerials(typePublicCode, serialNumberStart, count, idCompany) {
      let act = {        
        typePublicCode: typePublicCode,
        serialNumberStart: serialNumberStart,
        count: count,
        idCompany, idCompany
      }
      return ApiService.post(`/api/apk/paper-act-serials`, act)
    },

    updatePlombSerial(id, idCompany, status) {
      let act = {        
        id: id,
        idCompany: idCompany,
        status: status
      }
      return ApiService.put(`/api/apk/plomb-serial`, act)
    },

    updatePlombSerials(serialNumberStart, count, idCompany, status) {
      let act = {        
        serialNumberStart: serialNumberStart,
        count: count,
        idCompany: idCompany,
        status: status
      }
      return ApiService.put(`/api/apk/plomb-serials`, act)
    },

    updatePaperActSerial(id, idCompany, status) {
      let act = {        
        id: id,
        idCompany: idCompany,
        status: status
      }
      return ApiService.put(`/api/apk/paper-act-serial`, act)
    },

    updatePaperActSerials(serialNumberStart, count, idCompany, status) {
      let act = {        
        serialNumberStart: serialNumberStart,
        count: count,
        idCompany: idCompany,
        status: status
      }
      return ApiService.put(`/api/apk/paper-act-serials`, act)
    },

    deletePlombSerial(id) {
      return ApiService.delete(`/api/apk/plomb-serial/${id}`)
    },

    deletePaperActSerial(id) {
      return ApiService.delete(`/api/apk/paper-act-serial/${id}`)
    },
}

export default ApkService